/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Enum for the payment source.
 */
export enum CreditAccountPaymentSource {
  VIRTUAL = 'VIRTUAL',
  STRIPE = 'STRIPE',
  PAYPAL = 'PAYPAL',
}
